/**
 * App endpoints.
 *
 * @remarks
 * This is a constant object that contains all the app endpoints.
 *
 * @example
 * import { APP_ENDPOINTS } from 'app/utils/app-endpoints';
 *
 * console.log(APP_ENDPOINTS.LOGIN); // '/login'
 */
export const APP_ENDPOINTS = {
  LOGIN: '/login',
  SABHA: '/sabha',
  SIGNOUT: '/signOut',
  ROLES: '/roles',
  GENERAL_PERMISSIONS: '/general-permissions',
  GROUP_PERMISSIONS: '/group-permissions',
  PROFILE_PERMISSIONS: '/profile-permissions',
  POOL_PERMISSIONS: '/pool-permissions',
  WATCHLIST_PROFILE_PERMISSIONS: '/watchlist-profile-permissions',
  DASHBOARD: '/dashboard',
  GROUP_SETTINGS: '/settings/groupSettings',
  DASHBOARD_ERROR: '/dashboardError',
  SUPPORT_REQUEST: '/supportrequests',
};

type SanitizedMap = {
  [K in keyof typeof APP_ENDPOINTS]: string;
};

/**
 * Sanitized app endpoints.
 *
 * @remarks
 * This is a constant object that contains all the app endpoints sanitized.
 *
 * @example
 * import { APP_ENDPOINTS_SANITIZED } from 'app/utils/app-endpoints';
 *
 * console.log(APP_ENDPOINTS_SANITIZED.LOGIN); // 'login'
 */
export const APP_ENDPOINTS_SANITIZED: SanitizedMap = Object.keys(APP_ENDPOINTS).reduce(
  (acc, key) => ({ ...acc, [key]: sanitizeEndpoint(APP_ENDPOINTS[key]) }),
  {} as SanitizedMap
);

function sanitizeEndpoint(endpoint: string): string {
  return endpoint.replace('/', '');
}
